import { z } from "zod";

export const SearchCategorySchema = z.enum([
  "all",
  "articles",
  // "podcasts",
  // "videos",
  "playlists",
  "journals",
  "rooms",
]);

export type SearchCategory = z.infer<typeof SearchCategorySchema>;

export const SearchScopeSchema = z.enum(["room", "global"]).catch("room");
export type SearchScopeValue = z.infer<typeof SearchScopeSchema>;

export type SearchScope = { kind: "room"; roomId: string } | { kind: "global" };
